// extracted by mini-css-extract-plugin
export default {"error404":"NotFound_error404__BMlaI","container":"NotFound_container__BtUWT"};